import React from 'react';
import { Box, Typography } from '@mui/material';

function Footer() {
  return (
    <Box 
      component="footer" 
      sx={{
        width: '100%',
        padding: '16px',
        backgroundColor: '#f1f1f1',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
    >
      <Typography variant="body2" color="text.secondary" align="center">
      ©2025 aqili. All rights reserved.
      </Typography>
    </Box>
  );
}

export default Footer;
